import { HeaderWrapper } from 'layouts';
import type { EventContentObjectDetail } from 'models';
import { useState } from 'react';
import { Col, HeaderAsset, HeaderContent, Row, ScrollToTop } from 'ui';
import { images } from 'common/utils';
import { BookmarkButton } from 'features/bookmark';
import { InviteesCount } from '../components';
import { EditEvent } from '../EditEvent';
import { useEventDropdownActions, useGetEventTagsProperties } from '../hooks';
import { ProgramEventRsvpStatus } from './program-event-rsvp-status';

type P = {
  eventContentObject: EventContentObjectDetail;
  onEventDeleted: () => void;
};

const ProgramEventHeader = ({ eventContentObject, onEventDeleted }: P) => {
  const {
    coverPhoto,
    endTime,
    eventType,
    goingInviteesCount,
    id,
    name,
    notGoingInviteesCount,
    pendingInviteesCount,
    startTime,
    status,
  } = eventContentObject.event;
  const tags = useGetEventTagsProperties({ endTime, eventType, startTime, status });

  const [modalAction, setModalAction] = useState<'duplicate' | 'edit'>();

  const handleRequestAction = (action: 'duplicate' | 'edit') => {
    setModalAction(action);
  };

  const { contextHolders, getActions } = useEventDropdownActions({
    onEventDeleted,
    onRequestAction: handleRequestAction,
    view: 'program',
  });

  return (
    <>
      <ScrollToTop />
      <HeaderWrapper
        left={
          <HeaderAsset image={{ alt: 'Event cover photo', src: coverPhoto?.url ?? images.default.eventCoverPhoto }} />
        }
        right={
          <HeaderContent
            actions={getActions({ eventContentObject })}
            extra={
              <Row gutter="xs">
                <Col>
                  <ProgramEventRsvpStatus
                    authorId={eventContentObject.author.nodeUserId}
                    event={eventContentObject.event}
                  />
                </Col>
                <Col>
                  <BookmarkButton contentObject={eventContentObject} />
                </Col>
              </Row>
            }
            tags={tags}
            timeInfo={{ dateFrom: startTime, dateTo: endTime }}
            title={name}
          >
            <InviteesCount
              eventType={eventType}
              inviteesCount={{
                going: goingInviteesCount,
                notGoing: notGoingInviteesCount,
                pending: pendingInviteesCount,
              }}
            />
          </HeaderContent>
        }
      />
      <EditEvent
        eventId={id}
        isOpened={modalAction !== undefined}
        mode={modalAction ?? 'edit'} // TODO default value or optional?
        onCancel={() => {
          setModalAction(undefined);
        }}
        onSuccess={() => {
          setModalAction(undefined);
        }}
      />
      {contextHolders}
    </>
  );
};

export default ProgramEventHeader;
